<template>
	<div class="ks-videoeditor-inspector-body">
		<template v-if="pair && pair.consecutive">
			<div class="ks-videoeditor-meta"><b>{{ pair.first.title }}</b> &rarr; <b>{{ pair.second.title }}</b></div>
			<transition-field title="Transition between clips" :value="pair.second.transition" @input="change">
				<div class="ks-videoeditor-meta">Choosing a transition moves the second clip right after the first one. A fade overlaps the two clips by its length, so the timeline gets shorter by that amount.</div>
			</transition-field>
		</template>
		<div v-else class="ks-videoeditor-meta">Shift-click two consecutive clips on the same track to set a transition between them.</div>
	</div>
</template>

<script>
import TransitionField from './TransitionField.vue'

// Transition between two shift-selected clips. A changed type is emitted as pair-transition so the second clip can be moved next to the first.
export default {
	components: {TransitionField},
	props: {
		pair: Object
	},
	methods: {
		change (transition) {
			const second = this.pair.second;
			if (transition.type != second.transition.type) this.$emit("pair-transition", transition.type);
			else this.$emit("update", second, {transition: transition});
		}
	}
}
</script>
